// extracted by mini-css-extract-plugin
export default {"interesting":"MightBeInteresting_interesting__ggDsz"};